import React from 'react'

import cx from 'classnames'

import styles from './Loading.module.css'

export const enum LoadingVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LINK = 'link'
}

export interface LoadingProps {
  variant?: LoadingVariant
}

export const Loading = ({ variant }: LoadingProps) => {
  return (
    <div className={cx(styles.loading, styles[variant])}>
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  )
}
